import useModelStoreModule from '@/views/models/common/useModelStoreModule'
import domainDnsRecordModel from '@/views/models/domains/domainDnsRecordModel'
import domainModel from './domainModel'

const {
  fetchAll,
  fetchOne,
  create,
  update,
  deleteOne,
} = useModelStoreModule(domainModel)

const {
  update: updateDnsRecord,
  fetchAllChildren,
  createChild,
  updateChild,
} = useModelStoreModule(domainModel, true)

const {
  deleteOne: deleteDnsRecord,
} = useModelStoreModule(domainDnsRecordModel)

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll,
    fetchOne,
    create,
    update,
    deleteOne,

    fetchDnsRecords: (ctx, id) => fetchAllChildren(ctx, id, 'dns-records', {}),
    createDnsRecord: (ctx, payload) => createChild(ctx, { id: payload.domainId, childResourceName: 'dns-records', payload }),
    updateDnsRecord: (ctx, payload) => updateChild(ctx, {
      id: payload.domainId, childResourceName: 'dns-records', childId: payload.id, payload,
    }),
    deleteDnsRecord: (ctx, payload) => deleteOne(ctx, { ...payload, id: `${payload.domainId}/dns-records/${payload.id}` }),
  },
}
